[
  {
    "version": "3.2",
    "releaseDate": "11/15/2026",
    "changes": [
      {
        "description": "Major improvements to app accessibility",
        "type": "new"
      },
      {
        "description": "Interactive product tour",
        "type": "new"
      },
      {
        "description": "Scale Factor for changing the size of text and user interface elements",
        "type": "new"
      },
      {
        "description": "Support for adding special characters in text fields",
        "type": "new"
      },
      {
        "description": "More intuitive tools for deleting marked points",
        "type": "new"
      },
      {
        "description": "Show points along with the origin, scale, and measurement tools",
        "type": "new"
      },
      {
        "description": "Show vectors for all objects simultaneously",
        "type": "new"
      },
      {
        "description": "Show origin and scale on the exported video image",
        "type": "new"
      }
    ]
  },
  {
    "version": "3.1",
    "releaseDate": "8/19/2025",
    "changes": [
      {
        "description": "Angle measurement tool",
        "type": "new"
      },
      {
        "description": "Interact directly with the graph axes to change the scaling",
        "type": "new"
      },
      {
        "description": "Graph legend visibility improved",
        "type": "new"
      },
      {
        "description": "Accessibility improvements",
        "type": "new"
      },
      {
        "description": "Run-time language selection",
        "type": "new"
      },
      {
        "description": "Export values via CSV",
        "type": "new"
      },
      {
        "description": "New minimum operating system levels:",
        "details": ["macOS 13", "Windows 10 version 22H2", "Android 13", "ChromeOS 132", "iOS 17"],
        "type": "change"
      }
    ]
  },
  {
    "version": "3.0.1",
    "releaseDate": "10/14/2024",
    "changes": [
      {
        "description": "App properly updates calculated column definitions when column names change.",
        "type": "fix"
      }
    ]
  },
  {
    "version": "3.0.0",
    "releaseDate": "06/25/2024",
    "changes": [
      {
        "description": "Distance measuring tool.",
        "type": "new"
      },
      {
        "description": "Support for many high efficiency video formats.",
        "type": "new"
      },
      {
        "description": "Compatibility with ChromeOS managed installation in an activated state.",
        "type": "new"
      },
      {
        "description": "Manual linear fits with draggable lines.",
        "type": "new"
      },
      {
        "description": "Export to PDF on iOS, iPadOS, and Android works again.",
        "type": "fix"
      }
    ]
  },
  {
    "version": "2.12.2",
    "releaseDate": "12/11/2023",
    "changes": [
      {
        "description": "Access control issues.",
        "type": "fix"
      },
      {
        "description": "Corrected placement of points when points are marked manually while autotracking is turned on.",
        "type": "fix"
      }
    ]
  },
  {
    "version": "2.12.1",
    "releaseDate": "11/13/2023",
    "changes": [
      {
        "description": "Corrected order of input columns for the arctan2 calculated column definition.",
        "type": "fix"
      },
      {
        "description": "App won't lock up after multiple entries of expired authorization keys.",
        "type": "fix"
      }
    ]
  },
  {
    "version": "2.12",
    "releaseDate": "11/6/2023",
    "changes": [
      {
        "description": "Strikethrough unwanted data.",
        "type": "new"
      },
      {
        "description": "Additional functions in custom calculated columns.",
        "type": "new"
      },
      {
        "description": "Display uncertainty of curve fit parameters.",
        "type": "new"
      },
      {
        "description": "Enhanced annotations functionality allows user to associate an annotation with a data point or a range of data.",
        "type": "new"
      },
      {
        "description": "Units included in linear and proportional curve fits.",
        "type": "new"
      },
      {
        "description": "Linked X axes in multiple graphs for simultaneous examine lines and grouped scaling.",
        "type": "new"
      },
      {
        "description": "Contextual menu for easy access to operations on graph selections.",
        "type": "new"
      },
      {
        "description": "Right Y axis graph option.",
        "type": "new"
      },
      {
        "description": "Object list now displays more entries for center of mass calculations.",
        "type": "fix"
      },
      {
        "description": "Improved pinch to zoom behavior on iOS and ChromeOS.",
        "type": "fix"
      }
    ]
  },
  {
    "version": "2.11.0",
    "releaseDate": "10/03/2022",
    "changes": [
      {
        "type": "new",
        "description": "Error bar plotting on graphs."
      },
      {
        "type": "new",
        "description": "Adjustable number of points used in derivative calculations."
      },
      {
        "type": "new",
        "description": "Additional functions in custom calculated columns."
      },
      {
        "type": "new",
        "description": "File Save/Open now uses system dialogs when possible."
      },
      {
        "type": "fix",
        "description": "Improved support for copy and paste to and from Excel."
      },
      {
        "type": "fix",
        "description": "Improved video playback on Safari browser."
      }
    ]
  },
  {
    "version": "2.10.1",
    "releaseDate": "6/27/2022",
    "changes": [
      {
        "type": "fix",
        "description": "Authentication issue."
      }
    ]
  },
  {
    "version": "2.10.0",
    "releaseDate": "6/14/2022",
    "changes": [
      {
        "type": "new",
        "description": "Information boxes with curve fit and statistics information can now be moved anywhere in the graph window, as well as set to a collapsed state."
      },
      {
        "type": "new",
        "description": "Vernier Video Analysis can now be used in multiple tabs simultaneously."
      },
      {
        "type": "fix",
        "description": "Apple Pencil can now be used to mark points and navigate in the application."
      },
      {
        "type": "fix",
        "description": "Videos now play and single-step correctly in recent releases of iPadOS and iOS."
      },
      {
        "type": "fix",
        "description": "Frame rate overrides now work more consistently."
      },
      {
        "type": "fix",
        "description": "Pinch to zoom now works more consistently on touch devices."
      }
    ]
  },
  {
    "version": "2.9.0",
    "releaseDate": "9/22/2021",
    "changes": [
      {
        "type": "new",
        "description": "More text is available to be copied to the clipboard such as fit information in curve fit information boxes."
      },
      {
        "type": "fix",
        "description": "Copy graph command restored to Graph Export on compatible browsers."
      },
      {
        "type": "fix",
        "description": "Videos are no longer displayed with incorrect aspect ratio on opening a file."
      },
      {
        "type": "fix",
        "description": "Zoom works more reliably on touch devices."
      },
      {
        "type": "fix",
        "description": "Improved layout on small screen devices."
      },
      {
        "type": "fix",
        "description": "Object color assignments are again respected."
      }
    ]
  },
  {
    "version": "2.8.0",
    "releaseDate": "6/16/2021",
    "changes": [
      {
        "type": "new",
        "description": "Dark Mode display follows OS settings and can be enabled in Presentation settings"
      },
      {
        "type": "fix",
        "description": "PDF export now works more reliably in Safari browser on iOS 13"
      },
      {
        "type": "fix",
        "description": "Certain videos no longer fail to load the correct frame"
      }
    ]
  },
  {
    "version": "2.7.0",
    "releaseDate": "3/31/2021",
    "changes": [
      {
        "type": "new",
        "description": "New control over column color, point symbols, and column selection"
      },
      {
        "type": "new",
        "description": "Improved color contrast and font size responsiveness for better accessibility"
      },
      {
        "type": "new",
        "description": "Improved experience for small screen devices"
      },
      {
        "type": "new",
        "description": "Export graph images as a PDF as a file or for printing"
      },
      {
        "type": "issue",
        "description": "On some versions of macOS Safari no Save as… dialog is shown when expected. Instead, a copy of the .vmbl file is silently saved in the user’s default download location using a unique default file name."
      }
    ]
  },
  {
    "version": "2.6.0",
    "releaseDate": "2/17/2021",
    "changes": [
      {
        "type": "new",
        "description": "User-defined calculated columns"
      },
      {
        "type": "issue",
        "description": "On some versions of macOS Safari no Save as… dialog is shown when expected. Instead, a copy of the .vmbl file is silently saved in the user’s default download location using a unique default file name."
      }
    ]
  },
  {
    "version": "2.5.0",
    "releaseDate": "1/27/21",
    "changes": [
      {
        "type": "new",
        "description": "Custom curve fit expressions can now be entered by the user."
      },
      {
        "type": "new",
        "description": "Vector displays can now extend a limited distance outside of the video canvas."
      },
      {
        "type": "issue",
        "description": "On some versions of macOS Safari no Save as… dialog is shown when expected. Instead, a copy of the .vmbl file is silently saved in the user’s default download location using a unique default file name."
      }
    ]
  },
  {
    "version": "2.4.0",
    "releaseDate": "11/18/20",
    "changes": [
      {
        "type": "new",
        "description": "Notes field is now available in the View menu."
      },
      {
        "type": "fix",
        "description": "Polar coordinate graph traces are no longer black."
      },
      {
        "type": "issue",
        "description": "On some versions of macOS Safari no Save as… dialog is shown when expected. Instead, a copy of the .vmbl file is silently saved in the user’s default download location using a unique default file name."
      }
    ]
  },
  {
    "version": "2.3.0",
    "releaseDate": "9/30/20",
    "changes": [
      {
        "type": "new",
        "description": "Support for videos captured in .mp4 format using ChromeOS Camera app."
      },
      {
        "type": "fix",
        "description": "Object position data now saved correctly in files when origin has been moved."
      },
      {
        "type": "fix",
        "description": "Marked points can be deleted more reliably."
      }
    ]
  },
  {
    "version": "2.2.1",
    "releaseDate": "9/21/20",
    "changes": [
      {
        "type": "fix",
        "description": "Authentication page now redirects correctly, fixing a problem with ChromeOS distribution of the app."
      }
    ]
  },
  {
    "version": "2.2.0",
    "releaseDate": "9/2/20",
    "changes": [
      {
        "type": "new",
        "description": "Polar coordinate system can be activated in Origin overlay"
      },
      {
        "type": "fix",
        "description": "Marking cursor again confined to video area"
      }
    ]
  },
  {
    "version": "2.1.0",
    "releaseDate": "8/19/20",
    "changes": [
      {
        "type": "new",
        "description": "Scaling and Origin location overlays are now separate views"
      },
      {
        "type": "new",
        "description": "Scale button is renamed System in preparation for later features"
      }
    ]
  },
  {
    "version": "2.0.0",
    "releaseDate": "8/5/20",
    "changes": [
      {
        "type": "new",
        "description": "Auto Tracking"
      },
      {
        "type": "new",
        "description": "Point Vector Display"
      },
      {
        "type": "fix",
        "description": "Videos in an incompatible format show a useful error"
      }
    ]
  },
  {
    "version": "1.9.0",
    "releaseDate": "7/8/20",
    "changes": [
      {
        "type": "new",
        "description": "Improved use of screen area on small devices"
      },
      {
        "type": "fix",
        "description": "Point marking on iOS is now more reliable"
      },
      {
        "type": "fix",
        "description": "Welcome dialog now scrolls correctly"
      }
    ]
  },
  {
    "version": "1.8.0",
    "releaseDate": "6/24/20",
    "changes": [
      {
        "type": "new",
        "description": "Long column names are now truncated more readably in Data Table and Graph"
      },
      {
        "type": "new",
        "description": "You can now zoom into video for more accurate marking of points"
      },
      {
        "type": "fix",
        "description": "View of video, graph and table now restored correctly on opening files"
      }
    ]
  },
  {
    "version": "1.7.0",
    "releaseDate": "5/28/20",
    "changes": [
      {
        "type": "new",
        "description": "Objects can be renamed, with name used in data table and graph labels"
      },
      {
        "type": "fix",
        "description": "Copy and paste function now works correctly on Safari and Firefox"
      },
      {
        "type": "fix",
        "description": "Graph image export now works consistently for two-graph view"
      },
      {
        "type": "fix",
        "description": "Files saved in certain locales including Finnish, Turkish and Russian now open successfully"
      }
    ]
  },
  {
    "version": "1.6.0",
    "releaseDate": "5/14/20",
    "changes": [
      {
        "type": "new",
        "description": "Center of Mass calculation and plotting"
      },
      {
        "type": "new",
        "description": "Trim start and end of video to focus analysis on most useful segment"
      },
      {
        "type": "new",
        "description": "Export graph image or video image with overlay, via file or clipboard, for use in reports"
      }
    ]
  },
  {
    "version": "1.5.0",
    "releaseDate": "4/29/20",
    "changes": [
      {
        "type": "new",
        "description": "Replay video and graph together"
      },
      {
        "type": "new",
        "description": "Additional calculated column options"
      },
      {
        "type": "change",
        "description": "Updated End User License Agreement for more locations"
      },
      {
        "type": "fix",
        "description": "Graph rescales correctly after changing what is plotted"
      }
    ]
  },
  {
    "version": "1.4.0",
    "releaseDate": "4/15/20",
    "changes": [
      {
        "type": "new",
        "description": "Cartesian coordinate system can be rotated"
      },
      {
        "type": "new",
        "description": "Object color can be manually set"
      },
      {
        "type": "new",
        "description": "Application is now localized"
      },
      {
        "type": "change",
        "description": "Additional options for skipping frames"
      },
      {
        "type": "fix",
        "description": "Vertical videos are no longer clipped on Safari and Firefox"
      },
      {
        "type": "fix",
        "description": "Improved behavior when adding points using iPadOS/iOS 13.4 and newer"
      },
      {
        "type": "fix",
        "description": "Video loading failure for certain file open sequences"
      }
    ]
  },
  {
    "version": "1.3.0",
    "releaseDate": "4/1/20",
    "changes": [
      {
        "type": "new",
        "description": "Adjusting the examine line in a graph snaps video to that time"
      },
      {
        "type": "new",
        "description": "Sample videos can be downloaded and cached for later use"
      },
      {
        "type": "change",
        "description": "Updated Cookie Notice and End User License Agreement"
      },
      {
        "type": "fix",
        "description": "Improved keyboard accessibility for point marking"
      },
      {
        "type": "fix",
        "description": "Improved support for iOS and iPadOS 13.4"
      }
    ]
  },
  {
    "version": "1.2.0",
    "releaseDate": "3/18/20",
    "changes": [
      {
        "type": "new",
        "description": "Multiple object marking using the new Objects menu"
      },
      {
        "type": "new",
        "description": "Video settings tool allows the analysis frame rate to be set for videos that do not play back in real time"
      },
      {
        "type": "new",
        "description": "Sample videos are easily accessible in Welcome dialog"
      },
      {
        "type": "fix",
        "description": "More video formats can be inserted"
      }
    ]
  },
  {
    "version": "1.1.0",
    "releaseDate": "3/4/20",
    "changes": [
      {
        "type": "new",
        "description": "Distribute App feature in More Options Menu assists instructors in distributing app to students"
      },
      {
        "type": "new",
        "description": "Examine lines in two-graph view are linked for simplified analysis"
      },
      {
        "type": "fix",
        "description": "Point editing is more reliable"
      }
    ]
  },
  {
    "version": "1.0.0",
    "releaseDate": "1/22/20",
    "changes": [
      {
        "type": "new",
        "description": "Insert video"
      },
      {
        "type": "new",
        "description": "Track single object"
      },
      {
        "type": "new",
        "description": "Set video scale and origin location"
      },
      {
        "type": "new",
        "description": "Skip frames while marking points or stepping through video"
      },
      {
        "type": "new",
        "description": "Timestamp of first marked frame is zero, even if it is not the first frame in the video"
      },
      {
        "type": "new",
        "description": "Edit and delete marked points"
      },
      {
        "type": "new",
        "description": "Display or hide trails of marked points"
      },
      {
        "type": "new",
        "description": "Graph/Table/Video panes can be resized"
      },
      {
        "type": "new",
        "description": "New vmbl file format saves the video within the same file for easier sharing"
      },
      {
        "type": "issue",
        "description": "Known issue: Some videos do not play or display on iOS and iPadOS devices. A new video processing system will be introduced in an upcoming release to provide improved compatibility with multiple video formats."
      }
    ]
  },
  {
    "version": "0.4.0",
    "releaseDate": "1/8/20",
    "changes": [
      {
        "type": "fix",
        "description": "Corrected issues where frames would be skipped on some videos"
      },
      {
        "type": "new",
        "description": "Initial support for iOS and iPadOS"
      },
      {
        "type": "new",
        "description": "Better support for variable frame rate videos, such as those captured by iOS and iPadOS devices"
      },
      {
        "type": "issue",
        "description": "Limitation: Files created prior to this release will have points in incorrect locations"
      },
      {
        "type": "issue",
        "description": "Known issue: Videos captured on iOS or iPadOS devices that were rotated 180° from standard landscape orientation will not advance correctly in Safari browser"
      }
    ]
  },
  {
    "version": "0.3.1",
    "releaseDate": "12/23/19",
    "changes": [
      {
        "type": "new",
        "description": "Drag to delete point feature makes it possible to remove points on touch screen devices"
      },
      {
        "type": "new",
        "description": "Position of last point added is now displayed even if trails are turned off"
      }
    ]
  },
  {
    "version": "0.3.0",
    "releaseDate": "12/11/19",
    "changes": [
      {
        "type": "fix",
        "description": "Opening saved files in Safari on macOS now correctly loads the video"
      },
      {
        "type": "new",
        "description": "Time stamp of first marked frame is now zero, even if it is not the first frame in the video"
      },
      {
        "type": "new",
        "description": "Number of skipped frames is saved and retrieved from files"
      },
      {
        "type": "new",
        "description": "Saved files now restore the current frame of the video rather than returning video to the first frame"
      },
      {
        "type": "issue",
        "description": "Limitation: Files previously saved prior to this release will no longer function properly"
      }
    ]
  },
  {
    "version": "0.2.0",
    "releaseDate": "12/2/19",
    "changes": [
      {
        "type": "fix",
        "description": "Issue with skipping frames on some videos"
      },
      {
        "type": "new",
        "description": "Added ability to skip frames while marking points or stepping through video"
      },
      {
        "type": "new",
        "description": "Two-graph view option"
      }
    ]
  },
  {
    "version": "0.1.0",
    "releaseDate": "10/31/19",
    "changes": [
      {
        "type": "new",
        "description": "Insert video"
      },
      {
        "type": "new",
        "description": "Track single object"
      },
      {
        "type": "new",
        "description": "Set scale and origin"
      },
      {
        "type": "new",
        "description": "Graph/Table/Video panes can be resized"
      },
      {
        "type": "issue",
        "description": "Limitation: Videos play and use their marked frame rates. If this frame rate is incorrect, such as for any slow-motion video, the time stamps will be proportionately incorrect."
      }
    ]
  }
]
